import { render, staticRenderFns } from "./authManage.vue?vue&type=template&id=4724fc3a&scoped=true&"
import script from "./authManage.vue?vue&type=script&lang=js&"
export * from "./authManage.vue?vue&type=script&lang=js&"
import style0 from "./authManage.vue?vue&type=style&index=0&id=4724fc3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4724fc3a",
  null
  
)

export default component.exports